<template>
  <!--    Loading spinner button-->
  <v-overlay
    v-if="show"
    opacity="0.2"
    :absolute="absolute"
    :z-index="zIndex"
  >
    <v-progress-circular
      indeterminate
      :color="'var(--v-primary-base)'"
      :size="size"
    />
  </v-overlay>
</template>

<script>
export default {
  name: 'LoaderComponent',

  props: {
    show: {
      type: Boolean,
      required: true
    },
    absolute: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: [Number, String],
      default: 2000
    },
    // Callers that overlay a small element (a row, a chip) rather than a whole
    // card need a spinner that fits inside it.
    size: {
      type: [Number, String],
      default: 60
    }
  }
}
</script>
